import SharedNavbar from '@/components/feature/SharedNavbar';
import SharedFooter from '@/components/feature/SharedFooter';
import { Seo } from '@/components/Seo';

// Required by Google/Facebook/Apple OAuth app review as a standalone "data
// deletion instructions" URL, distinct from the general Privacy Policy —
// they specifically check for a page a user can find on their own that
// tells them how to get their account and data deleted.
export default function DataDeletionPage() {
  return (
    <main className="w-full min-h-screen bg-white font-sans">
      <Seo title="Delete Your Account & Data — Rx.K Seoul" description="How to request permanent deletion of your Rx.K Seoul account and personal data." noindex />
      <SharedNavbar />

      <section className="w-full bg-[#1A1A1A] pt-28 pb-16 md:pt-32 md:pb-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white leading-[1.15] mb-4">
            Delete Your Account &amp; Data
          </h1>
        </div>
      </section>

      <section className="w-full bg-white py-16 md:py-24 px-6 md:px-12 lg:px-20">
        <div className="max-w-2xl mx-auto flex flex-col gap-6 text-sm text-[#5A5A5A] font-light leading-[1.9]">
          <p>
            You can request permanent deletion of your Rx.K Seoul account and all personal data associated with it
            (profile, order history, saved addresses) at any time — including if you signed up or logged in using
            Google or Facebook.
          </p>
          <div>
            <h2 className="font-serif text-lg font-bold text-[#2A2A2A] mb-2">How to request deletion</h2>
            <p>
              Email{' '}
              <a href="mailto:kseoulbd@gmail.com" className="text-[#7B1113] underline">
                kseoulbd@gmail.com
              </a>{' '}
              from the email address on your account (or include your registered phone number), with the subject
              line "Delete My Account". We will confirm and permanently delete your account and personal data within
              7 business days.
            </p>
          </div>
          <div>
            <h2 className="font-serif text-lg font-bold text-[#2A2A2A] mb-2">What gets deleted</h2>
            <p>
              Your profile (name, email, phone, saved addresses) and login access are permanently removed. Records
              we're legally required to keep for tax, accounting, or fraud-prevention purposes (e.g. past invoices)
              are retained only as long as the law requires, and are not linked back to an active account.
            </p>
          </div>
        </div>
      </section>

      <SharedFooter />
    </main>
  );
}
